import { enablePremiumPlanDiscount } from '@/lib/configs'
import { env } from '@/lib/runtime-env'
import {
  parsePremiumPlanDiscounts,
  type PremiumPlanDiscount,
  type PremiumPlanDiscounts,
} from '@/schemas/premium-plan-discount'

let cache: { raw: string | undefined; discounts: PremiumPlanDiscounts } | null = null

const getDiscounts = () => {
  const raw = env('NEXT_PUBLIC_PREMIUM_PLAN_DISCOUNT')
  if (!cache || cache.raw !== raw) cache = { raw, discounts: parsePremiumPlanDiscounts(raw) }
  return cache.discounts
}

/** Configured discount for a market product in the given currency; undefined while the flag is off. */
export const getPremiumPlanDiscount = (
  productId: string,
  currency: string,
): PremiumPlanDiscount | undefined => {
  if (!enablePremiumPlanDiscount() || !productId || !currency) return undefined
  return getDiscounts().get(productId)?.get(currency.trim().toUpperCase())
}
